'use client';

import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import TextInput from '@components/TextInput/TextInput';
import Button from '@commons/Button';
import { Search as SearchIcon } from '@icons';
import './_search.scss';

/**
 * Search input that navigates to the search page with the query as ?q=.
 *
 * The current query is passed in as defaultQuery rather than read from
 * useSearchParams, so the form stays usable outside a Suspense boundary.
 */
export default function SearchForm({
  searchDictionary = {},
  searchPageUrl = '/sok',
  defaultQuery = '',
  didSearch = undefined,
  className = ''
}) {
  const router = useRouter();
  const [input, setInput] = useState(defaultQuery);

  // Resync when the query in the URL changes (ex. back/forward navigation)
  useEffect(() => {
    setInput(defaultQuery);
  }, [defaultQuery]);

  const onSubmit = (e) => {
    e.preventDefault();
    const query = input.trim();
    if (!query) {
      return;
    }
    router.push(`${searchPageUrl || '/sok'}?q=${encodeURIComponent(query)}`);
    didSearch?.(query);
  };

  return (
    <form className={`Search__form ${className}`} onSubmit={onSubmit} role="search">
      <div className="Search__field-container">
        <div className="Search__icon" aria-hidden="true">
          <SearchIcon />
        </div>
        <TextInput
          className="Search__input"
          name="q"
          value={input}
          onChange={setInput}
          label={searchDictionary.buttonText || 'Søk'}
          labelVisuallyHidden={true}
          placeholder={searchDictionary.placeholder || ''}
        />
        <Button className="Search__submit" size="m" type="submit">
          {searchDictionary.buttonText || 'Søk'}
        </Button>
      </div>
    </form>
  );
}
